import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { appAxios } from "../../../axios/axios";
import { AxiosResponse } from "axios";
import { IResponse } from "../../../interfaces/requestResponse.interface";
import { IEnquiryChangeLogResponse } from "../../../interfaces/enquiry.interface";
import { ListSkeleton } from "../../Common/Ui/ListSkeleton";
import moment from "moment";

export const EnquiryChangeLogsModal: React.FC<{
  onClose: () => void;
  showChangeLogsModal: boolean;
  enquiryId: number;
}> = (props) => {
  const [changeLogsList, setChangeLogsList] = useState<
    IEnquiryChangeLogResponse[]
  >([]);

  const [logsListLoading, setLogsListLoading] = useState(false);

  const getEnquiryChangeLogs = async () => {
    setLogsListLoading(true);
    const changeLogsResponse: AxiosResponse<
      IResponse<IEnquiryChangeLogResponse[]>
    > = await appAxios.post("/query-management-staff/getEnquiryChangeLogs", {
      enquiryId: props.enquiryId,
    });

    if (changeLogsResponse.data.success) {
      setChangeLogsList(changeLogsResponse.data.result);
    }

    setLogsListLoading(false);
  };

  useEffect(() => {
    getEnquiryChangeLogs();
  }, []);

  return (
    <div>
      <Modal size="lg" show={props.showChangeLogsModal} onHide={props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">Enquiry Change Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {logsListLoading ? (
            <ListSkeleton count={2} skeletonHeight="40px" />
          ) : (
            changeLogsList.map((log) => (
              <li className="pb-2" style={{ fontSize: "13px" }}>
                {log.logString}
                <span className="text-primary">
                  Date : {moment(log.createdAt).format("DD-MM-YY HH:mm a")}
                </span>
              </li>
            ))
          )}
          {!changeLogsList.length && !logsListLoading && (
            <div className="text-danger text-center">No Logs Found!</div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
